import { Component, DOCUMENT, Inject, signal } from "@angular/core"
import { ReAuthenticationService } from "./reAuthentication.service"

@Component({
    selector: 'vco-authentication',
    template: `
        <dialog id="authenticationDialog">

            <h2 class="flex gap-2 items-center justify-center">
                <span class="material-icons-outlined text-danger">
                    warning_amber
                </span>
                {{ initialLogin() ? 'Please log in to continue' : 'Session expired' }}
            </h2>

            <p>Clicking "Open Login Page" will open the Calact login page in a new tab.  After you have successfully logged in return to this tab and click "Continue".</p>
            
            <div class="flex justify-end gap-2">
                <button
                    [class.tertiary]="loginClicked()"
                    [class.primary]="!loginClicked()"
                    (click)="openLogin()">
                    Open Login Page
                </button>
                <button
                    [class.tertiary]="!loginClicked()"
                    [class.primary]="loginClicked()"
                    (click)="continue()">
                    Continue
                </button>
            </div>
        </dialog>
    `,
    styles: `
        :host {
            dialog {
                max-width: 400px;
            }
        }
    `
}) export class AuthenticationComponent {
    constructor(
        private _reAuthenticationService: ReAuthenticationService,
        @Inject(DOCUMENT) private _document: Document,
        @Inject(Window) private readonly _window: Window
    ) {
        this._reAuthenticationService.authenticate.subscribe(this.reAuthenticate)
    }

    initialLogin = signal(false)

    reAuthenticate = (initialLogin: boolean) => {
        this.initialLogin.set(initialLogin)
        this._document.querySelector<HTMLDialogElement>('#authenticationDialog')?.showModal()
    }

    continue = () => {
        this.initialLogin()
            ? this._window.location.reload()
            : this._document.querySelector('dialog')?.close()
    }

    openLogin() {
        this.loginClicked.set(true);
        this._window.open('https://calact.org/login', '_blank');
    }

    readonly loginClicked = signal(false)
}